import React from 'react'
import AccountCreatedPage from '../../components/Merchant/MerchantOnboarding/AccountCreated';

const AccountCreated = () => {
  return (
    <AccountCreatedPage />
  )
}

export default AccountCreated;